import React, { Component } from 'react'
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {audioPreLoad} from './PlaySounds';
import {getGameCustomConfig } from '../actions/localActions'
import {playMainMusic} from './PlaySounds';
import {setLanguage} from '../actions/commonActions';

class SplashScreen extends Component {


  constructor(props){
      super(props);
      this.state = {
          error : null,
          isLoaded : false,
          configs : []          
      };
  }


  UNSAFE_componentWillMount(){
      audioPreLoad();
  }

      componentDidMount() {
        fetch('/game-skins/build-rev88-FwtEb7liF/data_'+this.props.language+'/game_custom_config.json')
        .then( response => response.json())
        .then(
            // handle the result
            (result) => {
                this.setState({
                    isLoaded : true,
                    configs : result
                });
            },

            // Handle error 
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                })
            },
        )
     
        setTimeout(
            function() {
                this.props.setLanguage('en');
                this.props.history.push('/mainmenu');
                playMainMusic();
            }
            .bind(this),
            4000
        );
      }
    

    render() {
      var pictures = [
        "/game-skins/build-rev88-FwtEb7liF/images/Splash.jpg",
        "/game-skins/build-rev88-FwtEb7liF/images/background.jpg",
        "/game-skins/build-rev88-FwtEb7liF/images/btn_english.png",
        "/game-skins/build-rev88-FwtEb7liF/images/btn_urdu.png",
        "/game-skins/build-rev88-FwtEb7liF/images/large_popup.png",
        "/game-skins/build-rev88-FwtEb7liF/images/popup_settings.png",
        "/game-skins/build-rev88-FwtEb7liF/images/popup_question.png",
        "/game-skins/build-rev88-FwtEb7liF/images/popup_answer.png",
        "/game-skins/build-rev88-FwtEb7liF/images/bg_score.png",
        "/game-skins/build-rev88-FwtEb7liF/images/bg_timer.png",
        "/game-skins/build-rev88-FwtEb7liF/images/btn_pause.png",
        "/game-skins/build-rev88-FwtEb7liF/images/switch_off.png",
        "/game-skins/build-rev88-FwtEb7liF/images/switch_on.png",
        "/game-skins/build-rev88-FwtEb7liF/images/virus_happy.png",
        "/game-skins/build-rev88-FwtEb7liF/images/virus_sad.png",

        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_intro_play.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_play.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_about.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_sources.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_settings.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_back.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_fact.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_free_play.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_main_menu.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_myth.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_next.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_play_again.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_restart.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_resume.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_time_challange.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/virus_correct.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/virus_wrong.png",
        "/game-skins/build-rev88-FwtEb7liF/images_en/btn_share.png",

        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_intro_play.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_play.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_about.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_sources.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_settings.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_back.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_fact.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_free_play.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_main_menu.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_myth.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_next.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_play_again.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_restart.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_resume.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_time_challange.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/virus_correct.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/virus_wrong.png",
        "/game-skins/build-rev88-FwtEb7liF/images_ur/btn_share.png",
        
      ];
      pictures.forEach((picture) => {
          const img = new Image();
          img.src = picture;
      });


            return(
                <div style = {{
                backgroundImage: "url(/game-skins/build-rev88-FwtEb7liF/images/background.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                height: "100vh",
                verticalAlign: "middle",
                display: "table-cell",
                width: "inherit",
                letterSpacing: "1px",
                fontSize: "45px",
                textShadow: "1px 3px 2px #ada8ad",
                lineHeight: 1.25
              }}>
                    {
                        this.state.configs.map(config => (config.GameTitle))
                    }
            </div>
            )
    }
}

SplashScreen.propTypes = {
  language:PropTypes.string.isRequired,
  error : PropTypes.string,
  isLoaded : PropTypes.bool,
  configs: PropTypes.array,
  setLanguage:PropTypes.func.isRequired
}

const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  error : null,
  isLoaded : false,
  configs: []
});

export default connect(mapStateToProps,{setLanguage})(SplashScreen);
// export default withRouter(SplashScreen,getGameConfig);


// WEBPACK FOOTER //
// ./src/components/SplashScreen.js